import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/product/tariff'
// Modules
import numbers from './numbers'

const initialState = () => ({
    tariffs: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        tariffs: state => state.tariffs.data,
        pagination: state => state.tariffs.pagination
    },
    actions: {
        /**
         * @param {{customerId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listTariffs: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listTariffs(data)
                const tariffs = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_TARIFFS, tariffs)
                return tariffs
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetTariffs: ({commit}) => commit(mutationTypes.RESET_TARIFFS)
    },
    modules: {
        numbers
    },
    mutations: {
        [mutationTypes.RESET_TARIFFS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_TARIFFS]: (state, data) => state.tariffs = data
    }
}
